/**
 * Converte data de reunião (YYYY-MM-DD ou ISO) para Date em **calendário local**,
 * evitando mostrar o dia anterior quando o backend envia meia-noite UTC.
 */
export function parseDataReuniaoLocal(raw) {
  if (raw == null || raw === '') return null;
  const s = String(raw);
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) {
    const y = parseInt(m[1], 10);
    const mo = parseInt(m[2], 10) - 1;
    const d = parseInt(m[3], 10);
    const dt = new Date(y, mo, d);
    return Number.isNaN(dt.getTime()) ? null : dt;
  }
  const dt = new Date(s);
  return Number.isNaN(dt.getTime()) ? null : dt;
}

export function formatarDataReuniaoCurta(raw) {
  const d = parseDataReuniaoLocal(raw);
  return d ? d.toLocaleDateString('pt-BR') : '—';
}

export function formatarDataReuniaoLonga(raw) {
  const d = parseDataReuniaoLocal(raw);
  if (!d) return '';
  return d.toLocaleDateString('pt-BR', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

export function isMesmoDiaCalendario(raw, outro = new Date()) {
  const d = parseDataReuniaoLocal(raw);
  if (!d) return false;
  return (
    d.getFullYear() === outro.getFullYear() &&
    d.getMonth() === outro.getMonth() &&
    d.getDate() === outro.getDate()
  );
}

export function isDataReuniaoPassada(raw) {
  const d = parseDataReuniaoLocal(raw);
  if (!d) return false;
  const hoje = new Date();
  hoje.setHours(0, 0, 0, 0);
  const cmp = new Date(d);
  cmp.setHours(0, 0, 0, 0);
  return cmp < hoje;
}
